function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 11.5332C3.22471 11.5332 0 12.1284 0 14.5093C0 16.8911 3.20458 17.5073 7 17.5073C10.7753 17.5073 14 16.913 14 14.5312C14 12.1494 10.7963 11.5332 7 11.5332Z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M7 9.26447C9.57172 9.26447 11.6322 7.20308 11.6322 4.63224C11.6322 2.0614 9.57172 0 7 0C4.42917 0 2.36777 2.0614 2.36777 4.63224C2.36777 7.20308 4.42917 9.26447 7 9.26447Z"
});

function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7fa3b980.svg";
export { ForwardRef as ReactComponent };